
import { getBytesCount,checkEnglishText } from '@utils/data';


const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateProductName = (rule, value, callback) => {
    if (getBytesCount(value) > 250) {
        return callback(new Error('字符数不能超过250'))
    }
    return callback()
}
const validateEnglishName = (rule, value, callback) => {
    if (checkEnglishText(value)) {
        callback(new Error('该模块不允许出现中文字符'));
    } else {
        callback();
    }
}
const validateProductWhExtAttr = (rule, value, callback) => {
    const { region1ShortName, region2Id } = value?.productOrigin || {}
    if (!region1ShortName) {
        return callback(new Error('必填'))
    } else if (region1ShortName == 'CN' && !region2Id) {
        return callback(new Error('省份必填'))
    }
    return callback()
}


const validateMaterialImgUrl = async (rule, value, callback, context) => {
    let errMsg = await context.$refs.materialImgRef.method_validImage()
    if (errMsg) {
        callback(new Error(errMsg));
    } else {
        callback();
    }

}
const validateGoodsLayerDecoration = async (rule, value, callback, context) => {
    let errMsg = await context.$refs.goodsLayerDecorationRef.method_validImage()
    if (errMsg) {
        callback(new Error(errMsg));
    } else {
        callback();
    }

}

const validateProductOuterPackageImages = async (rule, value, callback, context) => {
    const val = context.self_form.productOuterPackageInfo.productOuterPackageImages
    if (!val?.length) {
        return callback(new Error('外包装图片 不能为空'));
    }
    let errMsg = await context.$refs.productOuterPackageImagesRef.method_validImage()
    if (errMsg) {
        return callback(new Error(errMsg));
    } else {
        return callback();
    }
}
const validatePackageType = async (rule, value, callback, context) => {
    const val = context.self_form?.productOuterPackageInfo?.productOuterPackage?.packageType

    if (val === undefined || val === '') {
        return callback(new Error('必填'));
    }
    return callback();
}
const validatePackageShape = async (rule, value, callback, context) => {
    const val = context.self_form?.productOuterPackageInfo?.productOuterPackage?.packageShape
    if (val === undefined || val === '') {
        return callback(new Error('必填'));
    }
    return callback();
}


// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function (context) {
    return {
        categoryIds: [
            { required: true, message: '请选择类目' },
            { validator: validateCategoryIds }
        ],
        productName: [
            { required: true, message: '请输入商品名称' },
            { validator: validateProductName },
        ],
        productEnName:[
            {required: true, message: '请填写英文名称'},
            {validator: validateEnglishName}
        ],
        productWhExtAttr: [
            { required: true, message: '必填' },
            { validator: validateProductWhExtAttr },
        ],
        sizeType: [
            { required: true, message: '请选择尺码类型' }
        ],
        isBasePlate: [
            { required: true, message: '底板/套版' }
        ],
        basePlateSpecValue: [
            { required: true, message: '底板颜色' }
        ],
        materialImg: [
            { required: true, message: '必填' },
            { validator: contextWrap(validateMaterialImgUrl, context) }
        ],
        goodsLayerDecoration: [
            { validator: contextWrap(validateGoodsLayerDecoration, context) }
        ],
        productOuterPackageInfo: [
            { required: true, message: '必填' },
            // { validator: validateProductOuterPackageInfo },
        ],
        productOuterPackageImages: [
            { validator: contextWrap(validateProductOuterPackageImages, context) },
        ],
        packageType: [
            { validator: contextWrap(validatePackageType, context) },
        ],
        packageShape: [
            { validator: contextWrap(validatePackageShape, context) },
        ],
    };
}


export {
    RULES as default,
}
